export default "__VITE_ASSET__35c47bf0__"